import store from "../store/Index";

/**
 * Pre-flight permission check for the service layer.
 * Call this before dispatching API requests to fail fast
 * if the user lacks the required permission.
 *
 * Usage:
 *   checkPermission("booking.add_booking"); // throws if denied
 *
 * @throws Error with a descriptive message if denied.
 */
export const checkPermission = (permission: string): void => {
  const permissions =
    store.getState().auth.user?.permissions || [];
  if (!permissions.includes(permission.trim().replace(/'$/, ""))) {
    throw new Error(
      `Permission denied: you do not have the "${permission}" permission.`,
    );
  }
};

/**
 * Non-throwing variant — returns a boolean.
 */
export const hasStorePermission = (permission: string): boolean => {
  const permissions =
    store.getState().auth.user?.permissions || [];
  return permissions.includes(permission.trim().replace(/'$/, ""));
};
